/**
 * Remove empty text strings from Rich Text.
 *
 * @param {Array} content
 *
 * @returns {[String]}
 */
const filterEmptyContent = content => content.filter(text => !['', '/n'].includes(text));

export default filterEmptyContent;
